'use strict';

module.exports = function () {
	var $addToCart = $('#add-to-cart'),
		$addAllToCart = $('#add-all-to-cart'),
		$productSetList = $('#product-set-list');

	var updateAddToCartButtons = function () {
		if ($productSetList.find('.add-to-cart[disabled]').length > 0 || $addToCart.hasClass('add-to-cart-disabled')) {
			$addAllToCart.prop('disabled', true);
			// product set does not have an add-to-cart button, but product bundle does
			$addToCart.prop('disabled', true);
		} else {
			$addAllToCart.prop('disabled', false);
			$addToCart.prop('disabled', false);
		}
	};

	if ($productSetList.length > 0) {
		updateAddToCartButtons();
	}
};
